import type { Tweet } from "@podx/core/types";

export class SentimentAnalyzer {
  private positiveWords = ['bullish', 'moon', 'pump', 'gains', 'profit', 'surge', 'rally', 'bull', 'bullrun', 'green', 'up', 'rise', 'breakthrough', 'exploding', 'massive', 'huge', 'gem', 'diamond', 'undervalued'];
  private negativeWords = ['bearish', 'dump', 'crash', 'sell', 'loss', 'drop', 'decline', 'bear', 'red', 'down', 'fall', 'scam', 'rug', 'dump', 'selloff', 'bleeding', 'crash', 'rekt'];

  // Advanced sentiment scoring
  private sentimentWeights = {
    positive: 1.0,
    negative: -1.0,
    neutral: 0.0,
    very_positive: 1.5,
    very_negative: -1.5
  };

  analyzeSentiment(tweets: Tweet[]): 'positive' | 'negative' | 'neutral' {
    const sentimentScore = this.analyzeSentimentScore(tweets);
    return this.scoreToSentiment(sentimentScore);
  }

  analyzeSentimentScore(tweets: Tweet[]): number {
    let totalScore = 0;
    let totalWords = 0;

    for (const tweet of tweets) {
      const text = tweet.text.toLowerCase();
      const words = text.split(/\s+/);

      for (const word of words) {
        if (this.positiveWords.includes(word)) {
          totalScore += this.sentimentWeights.positive;
          totalWords++;
        } else if (this.negativeWords.includes(word)) {
          totalScore += this.sentimentWeights.negative;
          totalWords++;
        }
      }

      // Boost score for emojis and caps (indicating strong emotion)
      const capsRatio = (tweet.text.match(/[A-Z]/g) || []).length / tweet.text.length;
      if (capsRatio > 0.3) totalScore *= 1.2; // ALL CAPS = more emotion

      const emojiCount = (tweet.text.match(/[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]/gu) || []).length;
      if (emojiCount > 0) totalScore += emojiCount * 0.1;
    }

    return totalWords > 0 ? Math.max(-1, Math.min(1, totalScore / Math.max(totalWords, 1))) : 0;
  }

  scoreToSentiment(score: number): 'positive' | 'negative' | 'neutral' {
    if (score > 0.2) return 'positive';
    if (score < -0.2) return 'negative';
    return 'neutral';
  }
}
